import domain from "@/util/domain.js";
import permissions from "@/util/permissions.js";
import { getFilter } from "./helpers/getFilter";
import {
  operatorLogoUrl,
  languageFlagUrl,
  paymentMethodLogoUrl,
} from "@/util/assets";

export default {
  install(Vue) {
    // Decrypt URL in Image;
    Vue.prototype.$constructURL = function(keyS3) {
      // Olds images (Rules security);
      if (keyS3.split("___").length < 2) return undefined;

      // Separando a Crypto
      var crypto = keyS3.split("___")[1].slice(0, -4);

      // Se caso a imagem não for uma URL crypto;
      if (crypto.length <= 13) return undefined;

      // Decrypt
      var bytes = Vue.CryptoJS.Rabbit.decrypt(crypto, "secretKey123");
      var decryptedData = bytes.toString(Vue.CryptoJS.enc.Utf8);

      return decryptedData;
    };

    // Tratando o Operador que tem icones .png para os esportes
    Vue.prototype.$handlerIconsImgSports = async function(sports, size) {
      if (!permissions().customIcons.sports) return sports;
      const baseUrlS3 = `https://dozr8la71aog.cloudfront.net/domains/${domain()}/img/custom/icons/sports`;
      const promises = sports.map(async (sport) => {
        // tratano cenários onde a variavel id do esporte é diferente
        var id = sport.id_sport ? sport.id_sport : sport.id;
        var sizeImg = size === "large" ? "large" : "small";
        // Incluindo "icon_img" no objeto;
        sport.icon_img = `${baseUrlS3}/${id}_${sizeImg}.png`;
        return sport;
      });
      var newSports = await Promise.all(promises);
      return newSports;
    };

    function addMinutes(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    }

    Vue.prototype.$customIconsActive = function(hexColor) {
      return getFilter(hexColor);
    };

    Vue.prototype.$casinoStorage = {
      get({ type }) {
        const cachedStr = sessionStorage.getItem(`${type}Data`);
        const cachedJson = JSON.parse(cachedStr);

        if (cachedJson) {
          const now = new Date();
          const expiresAt = new Date(cachedJson.expiresAt);

          if (expiresAt > now) {
            return { isExpired: false, data: cachedJson };
          }
        }

        return { isExpired: true, data: [] };
      },

      set({ fields, type }) {
        const key = `${type}Data`;
        const cachedStr = sessionStorage.getItem(key);
        const cachedJson = JSON.parse(cachedStr);

        const newData = {
          ...cachedJson,
          ...fields,
          expiresAt: addMinutes(new Date(), 10),
        };

        sessionStorage.setItem(key, JSON.stringify(newData));
      },
    };

    // URLs de assets (CDN ou cópia local, por operador): src/util/assets.js
    Vue.prototype.$operatorLogoUrl = operatorLogoUrl;
    Vue.prototype.$languageFlagUrl = languageFlagUrl;
    Vue.prototype.$paymentMethodLogoUrl = paymentMethodLogoUrl;
    Vue.prototype.$lambdaUrl = () => {
      const lambdaPrefix = "cvi65hp68k";
      return `https://${lambdaPrefix}.execute-api.us-east-2.amazonaws.com`;
    };

    // Stack sga-lambda-assets-prod (us-east-2): rotas /listImagesCarousel e
    // /listImagesPopUp, sem prefixo /s3.
    Vue.prototype.$newCarouselAndPopupLambdaUrl = () => {
      const lambdaPrefix = "8tlnj3244h";
      return `https://${lambdaPrefix}.execute-api.us-east-2.amazonaws.com`;
    };

    // Handle Date Format
    (Vue.prototype.$handleDate = function(dateAndHour) {
      if (
        dateAndHour == null ||
        dateAndHour === "0000-00-00 00:00:00" 
      ) {
        return { 
          date: "-",
          hour: "-",
          dateAndHour: "-"
        };
      } else {
        // Verifica se o back está enviando só uma data, ex.: 2024-05-05 == length 10
        // E complementa com um horário mockado, pois evita um bug do toLocaleDateString(),
        // onde a data é subtraída em 1 dia quando não existe a info do horário.
        const isOnlyDate =
          dateAndHour.length == 10 &&
          new Date(`${dateAndHour} 00:00:00`).toLocaleDateString();

        return { 
          date: isOnlyDate ? isOnlyDate : new Date(dateAndHour).toLocaleDateString(),
          hour: new Date(dateAndHour).toLocaleTimeString(),
          dateAndHour: new Date(dateAndHour).toLocaleString()
        };
      }
    });
  },
};
